import React, { useEffect, useState } from 'react'
import {FaClone} from "react-icons/fa"
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Select from 'react-select'

const EmbedCodeModal = () => {

    const {camp_id} = useParams();
    const campaign_data = useSelector((state) => state.campaign.campaign_data);

    const [htmlCode,setHtmlCode] = useState({
        embedType:"html",
        embedCode:null,
        link:null
    })

    const [imagePersonalize,setImagePersonalize] = useState(false)

    const [autoResponder,setAutoResponder] = useState("activecampaign")

    const options = [
        {value: 'activecampaign', label: 'Active Campaign'},
        {value: 'mailchimp', label: 'Mailchimp'},
        {value: 'aweber', label: 'Aweber'},
        {value: 'getresponse', label: 'GetResponse'},
        {value: 'convertkit', label: 'Convert Kit'},
        {value: 'drip', label: 'Drip'},
        {value: 'ontraport', label: 'Ontraport'},
        {value: 'constant_contact', label: 'Constant Contact'},
        {value: 'icontact', label: 'iContact'},
        {value: 'sendlane', label: 'Sendlane'},
        {value: 'sendinblue', label: 'Sendinblue'},
        {value: 'hubspot', label: 'Hubspot'},
        {value: 'moosend', label: 'Moosend'},
        {value: 'omnisend', label: 'Omnisend'},
        {value: 'mailerlite', label: 'MailerLite'},
        {value: 'benchmark', label: 'Benchmark'},
        {value: 'klaviyo', label: 'Klaviyo'},
        {value: 'sendiio', label: 'Sendiio'},
    ]

    const [anchorLink,setAnchorLink] = useState(`https://www.vidconnect.net/page/${camp_id}?email=%EMAIL%&name=%FIRSTNAME%&last_name=%LASTNAME%`);
    const [personalizeParam,setPersonalizeParam] = useState("%FIRSTNAME%");
    const [copytext,setCopytext] = useState(`Copy Code`);

    useEffect(()=>{
        var dummyHtml = `<!DOCTYPE html><html><head> <meta charset="utf-8"> <meta name="viewport" content="width=device-width, initial-scale=1"> <title></title></head><body> <div style="margin: 0 auto; width: 100%; max-width: 360px; max-height: 260px;"> <table> <tr> <td></td><td rowspan=2> <a href="${anchorLink}" target="_blank" rel="noreferrer"> <img src="${campaign_data.gif_url}" style="max-width: 360px; max-height: 202px; text-align: center; display: table-cell; margin: auto;" alt="${campaign_data.name}"/> </a> </td></tr><tr> <td colspan=2 style="text-align: center;"><h1 style="color: #fff; font-family: 'Poppins', sans-serif; font-weight: 600; font-size: 16px;">Hello ${personalizeParam}</h1></td></tr></table> <div style="width: 100%; height: 50px; background: #fafafa; border-bottom-left-radius: 5px; border-bottom-right-radius: 5px; border: 1px solid rgba(117, 117, 117, 0.1); border-top: none;margin-left: 5px;"> <div style="padding-left: 10px; padding-top: 5px; font-size: 18px; font-weight: bold; letter-spacing: 0.3px; font-family: Open Sans; height: 23px;"> <a href="${anchorLink}" target="_blank" rel="noreferrer" style="color: #52a8be; text-decoration: none; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: block;" > ${campaign_data.name}</a> </div><div style="padding-left: 10px; padding-bottom: 5px; letter-spacing: 0.3px; font-family: Open Sans; font-size: 13px;"> <a href="${anchorLink}" target="_blank" rel="noreferrer" style="color: #757575; text-decoration: none;">Click to watch video</a> </div></div></div></body></html>`;
        var dummyHtml1 = `<!DOCTYPE html><html> <head> <meta charset="utf-8"/> <meta name="viewport" content="width=device-width, initial-scale=1"/> <title></title> </head> <body> <div style="margin: 0 auto; width: 100%; max-width: 360px; max-height: 260px;"> <div style="width: 100%; max-width: 360px; max-height: 202px; display: flex; background: #f6f6f6; border-top-left-radius: 5px; border-top-right-radius: 5px; border: 1px solid rgba(117, 117, 117, 0.1);"> <span style="width: 100%; min-height: 200px; max-height: 202px;"> <a href="${anchorLink}" target="_blank" rel="noreferrer"> <img src="${campaign_data.gif_url}" style="max-width: 360px; max-height: 202px; text-align: center; display: table-cell; margin: auto;" alt="${campaign_data.name}"/> </a> <span style="width: 100%; height: 100%;"></span> </span> </div><div style="width: 100%; height: 50px; background: #fafafa; border-bottom-left-radius: 5px; border-bottom-right-radius: 5px; border: 1px solid rgba(117, 117, 117, 0.1); border-top: none;"> <div style="padding-left: 10px; padding-top: 5px; font-size: 18px; font-weight: bold; letter-spacing: 0.3px; font-family: Open Sans; height: 23px;"> <a href="${anchorLink}" target="_blank" rel="noreferrer" style="color: #52a8be; text-decoration: none; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: block;" > ${campaign_data.name}</a> </div><div style="padding-left: 10px; padding-bottom: 5px; letter-spacing: 0.3px; font-family: Open Sans; font-size: 13px;"> <a href="${anchorLink}" target="_blank" rel="noreferrer" style="color: #757575; text-decoration: none;">Click to watch video</a> </div></div></div></body></html>`;
        if(imagePersonalize){
            setHtmlCode({
                ...htmlCode,
                embedCode:dummyHtml,
                link:anchorLink
            })
        }else{
            setHtmlCode({
                ...htmlCode,
                embedCode:dummyHtml1,
                link:anchorLink
            })
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[anchorLink,campaign_data,imagePersonalize])

    const handleCodeChange = (e) =>{
        // console.log(e.value)
        setAutoResponder(e.value)
        if(e.value === 'email')
            setAnchorLink(`https://www.vidconnect.net/page/${camp_id}`)
        if(e.value === 'activecampaign'){
            setPersonalizeParam("%FIRSTNAME%")
            setAnchorLink(`https://www.vidconnect.net/page/${camp_id}?email=%EMAIL%&name=%FIRSTNAME%&last_name=%LASTNAME%`)
        }
            
        if(e.value === 'mailchimp'){
            setPersonalizeParam(`*|NAME|*`)
            setAnchorLink(`https://www.vidconnect.net/page/${camp_id}?name=*|NAME|*`)
        }
        
        if(e.value === 'aweber'){
            setPersonalizeParam(`{!firstname}`)
            setAnchorLink(`https://www.vidconnect.net/page/${camp_id}?email={!email}&name={!firstname}&last_name={!lastname}`)
        }
            
        if(e.value === 'getresponse'){
            setPersonalizeParam(`[[name]]`)
            setAnchorLink(`https://www.vidconnect.net/page/${camp_id}?email=[[email]]&name=[[name]]&last_name=[[lname]]`)
        }
            
        if(e.value === 'convertkit') {
            setPersonalizeParam(`{{subscriber.first_name}}`)
            setAnchorLink(`https://www.vidconnect.net/page/${camp_id}?name={{subscriber.first_name}}`)
        } 
            
        if(e.value === 'drip') {
            setPersonalizeParam(`{{subscriber.first_name}}`)
            setAnchorLink(`https://www.vidconnect.net/page/${camp_id}?name={{subscriber.first_name}}`)
        }
            
        if(e.value === 'ontraport'){
            setPersonalizeParam(`[First Name]`)
            setAnchorLink(`https://www.vidconnect.net/page/${camp_id}?name=[First Name]`)
        } 
            
        if(e.value === 'constant_contact'){
            setPersonalizeParam(`[[First Name]]`)
            setAnchorLink(`https://www.vidconnect.net/page/${camp_id}?name=[[FirstName]]`)
        }
            
        if(e.value === 'icontact') {
            setPersonalizeParam(`[fname]`)
            setAnchorLink(`https://www.vidconnect.net/page/${camp_id}?name=[fname]`)
        }
            
        if(e.value === 'sendlane') {
            setPersonalizeParam(`VAR_FIRST_NAME`)
            setAnchorLink(`https://www.vidconnect.net/page/${camp_id}?name=VAR_FIRST_NAME`)
        }
            
        if(e.value === 'sendinblue') {
            setPersonalizeParam(`{{contact.FIRSTNAME}}`)
            setAnchorLink(`https://www.vidconnect.net/page/${camp_id}?name={{contact.FIRSTNAME}}`)
        }
            
        if(e.value === 'hubspot') {
            setPersonalizeParam(`{{contact.firstname}}`) 
            setAnchorLink(`https://www.vidconnect.net/page/${camp_id}?name={{contact.firstname}}`)
        }
            
        if(e.value === 'moosend') {
            setPersonalizeParam(`#recipient:name#`) 
            setAnchorLink(`https://www.vidconnect.net/page/${camp_id}?name=#recipient:name#`)
        } 
            
        if(e.value === 'omnisend') {
            setPersonalizeParam(`[[contact.first_name]]`) 
            setAnchorLink(`https://www.vidconnect.net/page/${camp_id}?name=[[contact.first_name]]`)
        }
        
        if(e.value === 'mailerlite') {
            setPersonalizeParam(`{$name}`) 
            setAnchorLink(`https://www.vidconnect.net/page/${camp_id}?name={$name}`)
        }
        
        if(e.value === 'benchmark') {
            setPersonalizeParam(`[contact_attribute:firstname]`) 
            setAnchorLink(`https://www.vidconnect.net/page/${camp_id}?name=[contact_attribute:firstname]`)
        } 
        
        if(e.value === 'klaviyo') {
            setPersonalizeParam(`{{first_name}}`) 
            setAnchorLink(`https://www.vidconnect.net/page/${camp_id}?name={{first_name}}`)
        }

        if(e.value === 'sendiio') {
            setPersonalizeParam("%name%") 
            setAnchorLink(`https://www.vidconnect.net/page/${camp_id}?email=%email_field%&name=%name%`)
        }
        
    }

    const handleEmbedCode = (e) =>{
        e.preventDefault();
        setHtmlCode({...htmlCode,embedType:e.target.value})
    }

    const handleCopy = (e) =>{

        
         /* Get the text field */
        var copyText = (htmlCode.embedType === 'html')? document.getElementById("embedCodegen") : document.getElementById("embedLink");

        if(htmlCode.embedType === 'html'){
             /* Select the text field */
            copyText.select();
            copyText.setSelectionRange(0, 99999); /* For mobile devices */
        }
       
        // /* Copy the text inside the text field */
        var copyValue = (htmlCode.embedType === 'html') ? copyText.value:copyText.innerText
        
        navigator.clipboard.writeText(copyValue)

        // copyFormatted(copyValue)
        
        setCopytext('Copied!')

        setTimeout(function(){
            setCopytext('Copy Code');
        },2000)
    }
    return (
        <>
            <div className="modal popup2" id="myModal4">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Embed Code</h4>
                            <button type="button" className="btn_close2" data-bs-dismiss="modal">
                                <i className="fa fa-close"></i></button>
                        </div>

                        <div className="modal-body p-4">
                            <form className="bg-white p-4 shadow rounded-1">
                                <label>Select Embed Type</label>
                                <select 
                                    className="form-select mb-4"
                                    onChange={handleEmbedCode}
                                    value={htmlCode.embedType}
                                >
                                    <option value="html">Embed Code</option>
                                    <option value="link">Get URL</option>
                                   
                                </select>
                                <label>Select Autoresponder</label>
                               
                                <Select 
                                    options={options} 
                                    onChange={handleCodeChange}
                                    value={options.filter(
                                        (option) =>
                                          option.value.toLowerCase() ===
                                          autoResponder.toLowerCase()
                                    )}
                                    className="mb-4"
                                />
                                
                                <div className="email-field-outer">
                                    <label htmlFor="inputPersonalize" className="col-form-label email-field-label">Personalize Text</label>
                                    <div className="col-sm-10">
                                        <input 
                                            className="content-text ms-3" 
                                            id="inputPersonalize"
                                            value={imagePersonalize}
                                            onChange={(e)=>setImagePersonalize(!imagePersonalize)}
                                            type="checkbox"
                                        />
                                    </div>
                                </div>
                                {htmlCode.embedType === "link" && (
                                    <div 
                                        className="form-control border-0 shadow-none mb-4 embedLink"
                                        readOnly
                                        id="embedLink"
                                    >
                                    {htmlCode.link}
                                    </div>
                                )}
                                {htmlCode.embedType === "html" && (
                                    <textarea 
                                        className="form-control textarea2 border-0 shadow-none mb-4"
                                        readOnly
                                        id="embedCodegen"
                                        defaultValue={htmlCode.embedCode}
                                    />
                                    
                                )} 
                                
                                <button 
                                    type="button" 
                                    className="btn1 copylinkbtn border-0 rounded-1 w-100 position-relative ps-3 pe-3"
                                    onClick={handleCopy}
                                >
                                    <FaClone className="text-white me-1"/>{copytext}</button>

                            </form>


                        </div>



                    </div>
                </div>
            </div>
        </>
    )
}

export default EmbedCodeModal